module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9cTC6"))).then(() => parcelRequire('dJXJK'));